/* Collection filters share metadata across format rows and product tiles. Choices that
   cannot match the other active groups are disabled. A restored or stale selection that
   matches nothing gets a message and an explicit reset, never a blank catalogue. */
if (!customElements.get('lab-shop-filters')) {
  const attributes = { processing: 'lav', format: 'fmt', profile: 'profile' };

  class LabShopFilters extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.addEventListener('change', (event) => {
        if (event.target.matches('input[data-shop-filter]')) this.update();
      }, { signal });
      this.querySelector('[data-filter-reset]')?.addEventListener('click', () => this.reset(), { signal });
      document.addEventListener('shopify:section:load', () => this.init(), { signal });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true, signal });
      } else this.init();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.items?.forEach((item) => { item.hidden = false; });
      this.groups?.forEach((group) => { group.hidden = false; });
    }

    init() {
      const shop = document.querySelector('#MainContent .lab-shop--shop');
      this.items = Array.from(shop?.querySelectorAll('[data-catalog-item]') || []);
      this.groups = Array.from(shop?.querySelectorAll('.pband, .shop-rows') || []);
      this.inputs = Array.from(this.querySelectorAll('input[data-shop-filter]'));
      this.hidden = this.items.length === 0;
      if (this.hidden) return;
      for (const input of this.inputs) {
        const present = input.value === 'all' || this.items.some((item) => this.matchesItem(item, { [input.dataset.shopFilter]: input.value }));
        input.closest('.cell').hidden = !present;
      }
      for (const group of this.querySelectorAll('fieldset')) {
        group.hidden = !Array.from(group.querySelectorAll('input')).some((input) => input.value !== 'all' && !input.closest('.cell').hidden);
      }
      this.update();
    }

    selection() {
      return Object.fromEntries(this.inputs.filter((input) => input.checked).map((input) => [input.dataset.shopFilter, input.value]));
    }

    matchesItem(item, selection) {
      return Object.entries(selection).every(([group, value]) => {
        if (value === 'all') return true;
        return (item.dataset[attributes[group]] || '').split(/\s+/).includes(value);
      });
    }

    update() {
      if (!this.items) return;
      const selected = this.selection();
      let count = 0;
      for (const item of this.items) {
        item.hidden = !this.matchesItem(item, selected);
        if (!item.hidden) count++;
      }
      for (const group of this.groups) {
        group.hidden = !Array.from(group.querySelectorAll('[data-catalog-item]')).some((item) => !item.hidden);
      }
      for (const input of this.inputs) {
        input.disabled = input.value !== 'all' && !input.checked && !this.items.some((item) => this.matchesItem(item, { ...selected, [input.dataset.shopFilter]: input.value }));
      }
      this.querySelector('[data-filter-empty]').hidden = count > 0;
      this.querySelector('[data-filter-status]').textContent = count > 0
        ? this.dataset.resultsText.replace('%count%', String(count))
        : this.querySelector('[data-filter-empty-text]').textContent;
    }

    reset() {
      for (const input of this.inputs) {
        if (input.value !== 'all') continue;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.update();
      this.inputs.find((input) => input.value === 'all' && !input.closest('fieldset').hidden)?.focus();
    }
  }
  customElements.define('lab-shop-filters', LabShopFilters);
}
